// extracted by mini-css-extract-plugin
export default {"Content":"style_Content__CCzlR","Wrapper":"style_Wrapper__x3fmr","Header":"style_Header__iHvY7","Body":"style_Body__h2apJ","keepSpaces":"style_keepSpaces__sIquU"};